import store from '@/store'

export const hasAlert = (_to, _from, next) => {
  const alerts = store.getters['alerts/past_due_alerts']()
  if(alerts[0]) {
    next({ name: `alerts/${alerts[0]}`})
    return
  }

  next()
}

// manually chaining requiresAuth and hasAlert, this should be changed
// when we migrate to vue 3 and vue-router 4
export const requiresAuth = (to, from, next) => {
  const isLoggedIn = store.getters['auth/signedIn']   
  if ( !isLoggedIn ) {
    next({ name: 'login' })
    return
  }

  return hasAlert(to, from, next)
}

export const requiresAuthNoAlert = (to, from, next) => {
  const isLoggedIn = store.getters['auth/signedIn']   
  if ( !isLoggedIn ) {
    next({ name: 'login' })
    return
  }

  next()    
}

export const skipIfLoggedIn = (_to, _from, next) => {
  const isLoggedIn = store.getters['auth/signedIn']   
  if ( isLoggedIn ) {
    next({ name: 'home' })
    return
  }

  next()    
}

export const logoutFirst = (_to, _from, next) => {
  const isLoggedIn = store.getters['auth/signedIn']   
  if ( isLoggedIn ) {
    store.dispatch('auth/logout')
  }

  next()
}

export const logout = (_to, _from, next) => {
  store.dispatch('auth/logout')
  next({ name: 'login' })
}